import { AccountCreateButton } from "./account.create.button";
import { AccountCreateForm } from "./account.create.form";

export const AccountCreate = {
    Button: AccountCreateButton,
    Component: AccountCreateForm,
}
